import axios from '../axios'
import Cookies from "js-cookie";
/* 
 * 上传
 */
// 新增管理员
export const uploadApi = data => {
  return axios({
    url: '/common/file',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization' : Cookies.get('token')
    }
  })
}



// WEBPACK FOOTER //
// ./src/http/api/upload.js